import { takeEvery, call, put, select } from "redux-saga/effects";
import {
  CHECK_AND_LOAD_OBJECT,
  loading,
  updateObject,
} from "../../store/Objects/actions";
import { showAlertError } from "../../store/Alert/actions";
import axios from "axios";

export default function* () {
  yield takeEvery(CHECK_AND_LOAD_OBJECT, worker);
}

function* worker({ payload }) {
  const { id } = payload;

  try {
    const ids = Array.isArray(id) ? id : [id];

    // Ранняя проверка — нет объектов для загрузки
    if (ids.length === 0) return;

    yield put(loading(true));

    const { statusObject, existingObjects } = yield select((state) => ({
      statusObject: state.objects.statusObject,
      existingObjects: state.objects.allObjects.filter((obj) =>
        ids.includes(obj.id),
      ),
    }));

    // Находим ID, которых нет в хранилище или без поля sn_hdd
    const idsToFetch = ids.filter((id) => {
      const obj = existingObjects.find((o) => o.id === id);
      return !obj || !("sn_hdd" in obj);
    });

    if (idsToFetch.length === 0) return;

    const response = yield call(fetchObjects, idsToFetch);

    if (response.error || !response.success?.length) {
      yield put(
        showAlertError({
          errors: ["Ошибка сервера при загрузке объектов"],
          text: "Не удалось загрузить данные объектов",
        }),
      );
      return;
    }

    const processedObjects = enrichAndSortObjects(
      response.success,
      statusObject,
    );

    yield put(updateObject(processedObjects));
  } catch (e) {
    console.error("Worker error:", e);
    yield put(
      showAlertError({
        errors: ["Ошибка сети при загрузке объектов"],
        text: "Не удалось загрузить данные объектов",
      }),
    );
  } finally {
    yield put(loading(false));
  }
}

function fetchObjects(ids) {
  return axios
    .get("/msbox/select", {
      params: { id: ids },
    })
    .then((response) => response.data);
}

// === Утилиты ===

function enrichAndSortObjects(objects, statusObject = {}) {
  // Обогащаем объекты
  const enriched = objects.map((obj) => ({
    ...obj,
    statusText: statusObject[obj.msstatus_id] ?? "",
    fullName: obj.alias ? obj.alias : `${obj.name} ${obj.address || ""}`,
  }));

  // Сортируем: сначала null-статусы, потом по статусу и имени
  const withStatus = [];
  const withoutStatus = [];

  for (const obj of enriched) {
    if (obj.msstatus_id === null) {
      withoutStatus.push(obj);
    } else {
      withStatus.push(obj);
    }
  }

  withoutStatus.sort((a, b) => a.fullName.localeCompare(b.fullName));
  withStatus.sort((a, b) => {
    if (a.msstatus_id !== b.msstatus_id) {
      return a.msstatus_id - b.msstatus_id;
    }
    return a.fullName.localeCompare(b.fullName);
  });

  // Финальная сборка с ID в начале fullName
  return [...withoutStatus, ...withStatus].map((obj) => ({
    ...obj,
    fullName: `${obj.id} ${obj.fullName}`,
  }));
}
